import {FormControl, FormGroup} from '@angular/forms';
import {AdjustmentComponentControls, SingleAdjustmentControlsnterface} from 'appAssets/descriptors/panel-accounts';
import {BaseValidationFrom} from '../base-validation.form';

export class AdjustmentForm extends BaseValidationFrom<SingleAdjustmentControlsnterface> {
    initForm(): void {
        this.form = new FormGroup({});
        this.controls = AdjustmentComponentControls();

        Object.keys(this.controls).forEach((key: string) => {
            const control = this.controls[key];
            this.form.addControl(control.name, new FormControl(control.value, control.validators));
        });
    }
}
